import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { AuthenticationState, AzureAD } from "react-aad-msal";
import { serviceSignIn } from "@culturehq/client";
import { Loader } from "@culturehq/components";

import { getToken } from "app/utils/firebaseConfig";
import msalConfig from "app/utils/msalConfig";
import { useProfile } from "app/context";
import { errorService } from "app/utils";

const MSALLogin = ({ location }) => {
  const [redirectPath, setRedirectPath] = useState();
  const { fetchedProfile } = useProfile();

  const handleServiceSignIn = ({ account }, token) => (
    serviceSignIn({
      email: account.userName,
      password: account.idToken.aud,
      method: "microsoft",
      token,
      device: "web"
    }).then(response => {
      const { apiKey: { user } } = response;
      fetchedProfile(user);
      setRedirectPath(user.organizations.length > 1 ? "/profile/organizations" : "/");
    }).catch(_ => {
      errorService.log("Redirect to login, msal login");
      setRedirectPath("/login");
    })
  );

  const sessionHandler = ({ login, logout, authenticationState, error, accountInfo }) => {
    switch (authenticationState) {
      case AuthenticationState.Authenticated:
        getToken()
          .then(token => handleServiceSignIn(accountInfo, token))
          .catch(_ => handleServiceSignIn(accountInfo, undefined));

        return <Loader loading />;
      case AuthenticationState.Unauthenticated:
        return <Loader loading />;
      case AuthenticationState.InProgress:
        return <Loader loading />;
      default:
        return <Loader loading />;
    }
  };

  if (redirectPath) {
    const { from } = location.state || { from: { pathname: redirectPath } };

    return <Redirect to={from} />;
  }

  return (
    <AzureAD provider={msalConfig} forceLogin>
      {
        sessionHandler
      }
    </AzureAD>
  );
};

export default MSALLogin;
